import { render, staticRenderFns } from "./MoveMenu.vue?vue&type=template&id=203bee2c&scoped=true&"
import script from "./MoveMenu.vue?vue&type=script&lang=js&"
export * from "./MoveMenu.vue?vue&type=script&lang=js&"
import style0 from "./MoveMenu.vue?vue&type=style&index=0&id=203bee2c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "203bee2c",
  null
  
)

export default component.exports